var _path, _path2, _path3;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgWifi2 = function SvgWifi2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    viewBox: "0 0 16 12",
    xmlns: "http://www.w3.org/2000/svg"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.091 6.598a7.188 7.188 0 0 0-2.336-1.656A6.841 6.841 0 0 0 8 4.36c-.946 0-1.882.198-2.755.582a7.188 7.188 0 0 0-2.336 1.656l1.454 1.544a5.134 5.134 0 0 1 1.669-1.184A4.887 4.887 0 0 1 8 6.543c.675 0 1.344.141 1.968.415a5.135 5.135 0 0 1 1.669 1.184l1.454-1.544Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M16 3.51C13.877 1.264 11 0 8 0S2.123 1.263 0 3.51l1.454 1.544C3.192 3.214 5.546 2.181 8 2.181c2.454 0 4.808 1.033 6.546 2.873L16 3.511Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.943 9.817 8 12l2.057-2.183a2.903 2.903 0 0 0-.944-.67 2.764 2.764 0 0 0-2.226 0 2.904 2.904 0 0 0-.944.67Z"
  })));
};

export default SvgWifi2;